/**
 * This file is used by both font-end and back-end.
 */

export { cast } from './text.mjs';

/**
 * Validates and casts value.
 *
 * @param {*} value Value to validate.
 * @param {object} instructions Type instructions.
 * @param {object} [options] Global options.
 * @param {function} [more] Validate another array of instructions on the same bundle level.
 * @returns {*} Value casted to the type.
 */

export function validate(value, instructions, options = {}, more = undefined) {
	if (value === '') return null;

	value = String(value != null ? value : '');

	// No need to validate when text is empty
	if (value === '') return value;

	return value;
}
